// import constant
import {
    SET_KYC_VALIDATE,
} from '../constant';

const initialValue = {
    isAuth: false
}
const account = (state = initialValue, action) => {
    switch (action.type) {
        case SET_KYC_VALIDATE:
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
}

export default account;